<script>
    import { scale, fade, fly, slide } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';
    import { onMount, onDestroy } from 'svelte';
    import { get } from 'svelte/store';

    import { user } from '../store/authStore';
    import { page, modal } from '../store/nav';
    import { lists } from '../store/lists';
    import { categories } from "../store/items";
    import { recurring } from "../store/recurring";
    import { filters, storeName, frequency, next } from "../store/filters-recurring"

    import { formatDate } from "../js/helper";

    import { idb } from '../db';

    import Icon from '../components/icon.svelte';

    export let back_nav = false;

    let categoriesInList = {};
    let recurringItems = [];

    onMount(async () => {
        console.group(`INFO: /lists/recurring .onMount`);
		await recurring.init();
        console.log(`$recurring`);console.log($recurring);
        console.log(`$categories`);console.log($categories);
        console.groupEnd();                   
	});    

    $: if($recurring){
        recurringItems = $recurring; 
        for (const filter in $filters) {
            if ( $filters[filter] ){
                console.log(`Filter(s) applied:`,filter,$filters[filter]);
                recurringItems = recurringItems.filter( item => item[filter] == $filters[filter]);
            }
        }

        categoriesInList = {};
        recurringItems.forEach(item => {
            categoriesInList[item.category]=true;
        });
    }
    const resetFilters = () => {
        console.log(`RESET FILTERS`);
        storeName.set();
        frequency.set();
        next.set();
    }

    onDestroy(() => {
        idb.save('pc_recurring', $recurring);
        console.group(`INFO: lists/recurring .onDestroy`);console.log($recurring);console.groupEnd();
    });
</script>

<section id="list" in:fly="{{ x: back_nav ? -250 : 250, duration: 150 }}" out:fly="{{ x: 250, duration: 150, delay:150 }}" class="flex flex-col justify-between bg-primary fixed top-0 left-0 h-screen w-screen px-10">
        <section id="top-bar" class="flex mt-12 justify-between">
            <div id="back-btn" class="place-self-center" on:click={() => page.back('/lists')} >
                <svg viewBox="0 0 18 18" class="fill-secondary h-5" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7803 2.46967C12.0732 2.76256 12.0732 3.23744 11.7803 3.53033L6.31066 9L11.7803 14.4697C12.0732 14.7626 12.0732 15.2374 11.7803 15.5303C11.4874 15.8232 11.0126 15.8232 10.7197 15.5303L4.71967 9.53033C4.42678 9.23744 4.42678 8.76256 4.71967 8.46967L10.7197 2.46967C11.0126 2.17678 11.4874 2.17678 11.7803 2.46967Z"/>
                </svg>
            </div>
            
            <div id="title" class="place-self-center capitalize">Recurring items</div>
          
            <div id="title-menu" class="place-self-center" on:click|stopPropagation={() => modal.open(`/menu-lists-recurring?anchor=top`)} >
                <svg class="fill-secondary h-5" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 3C10.5 3.82843 9.82843 4.5 9 4.5C8.17157 4.5 7.5 3.82843 7.5 3C7.5 2.17157 8.17157 1.5 9 1.5C9.82843 1.5 10.5 2.17157 10.5 3Z"/>
                    <path d="M10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9Z"/>
                    <path d="M9 16.5C9.82843 16.5 10.5 15.8284 10.5 15C10.5 14.1716 9.82843 13.5 9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5Z"/>
                </svg>
            </div>
        </section>
        <section id="filters" class="mt-8 flex text-sm italic justify-between">
           <span>Filters:</span>
           <span class="place-self-center capitalize" on:click|stopPropagation={() => modal.open('/recurring-filters?anchor=top&filter=storeName')}>
                {#if $filters.storeName }
                    { $filters.storeName }
                {:else}
                    All stores
                {/if}
            </span>
            <span class="place-self-center capitalize" on:click|stopPropagation={() => modal.open('/recurring-filters?anchor=top&filter=frequency')}>
                {#if $filters.frequency }
                    { $filters.frequency }
                {:else}
                    All schedules
                {/if}
            </span>
            <span class="place-self-center" on:click|stopPropagation={() => modal.open('/recurring-filters?anchor=top&filter=next')}>
                {#if $filters.next }
                    { typeof $filters.next === 'number' ? formatDate.md($filters.next) : $filters.next}
                {:else}
                    All dates
                {/if}
            </span>
            <div on:click|stopPropagation={resetFilters}><Icon name="clear-box" class="w-3 place-self-center" /></div>
        </section>

        <section id="main" class="mt-7 flex flex-col space-y-10 grow overflow-auto no-scrollbar">
            {#each $categories as category}
            {#if categoriesInList[category]}
                <section class="category">
                    <section class="cat-icon">
                        <img class="h-12 m-auto" src="/img/icon/food/{category}.png" alt=""/>
                    </section>
                    <section class="cat-name font-bold text-2xl text-center capitalize mt-2.5">
                        <span>{category}</span>
                    </section>
                    <section class="cat-items mt-6 flex flex-col space-y-6">
                        {#if recurringItems}
                            {#each recurringItems as item}
                                {#if item.category == category}
                                <section class="flex items-stretch justify-between space-x-2.5" on:click|stopPropagation={()=>modal.open(`/update-recurring-item?item_uid=${item.uid}&selected_date=${item.next}&anchor=bottom`)}>
                                    <section class="item-start w-7 shrink-0 text-right place-self-center">
                                        <section class="list-logo">
                                            <img src="/img/stores/{item.storeUid}.png" alt="" class="w-5">
                                        </section>
                                    </section>
                                    <section class="item-name capitalize grow place-self-center">
                                        <span>{item.name}</span>
                                    </section>
                                    <section class="text-secondary text-sm italic place-self-center capitalize">
                                        {item.frequency}
                                    </section>
                                    <section class="text-secondary text-sm italic place-self-center">
                                        {formatDate.md(item.next)}
                                    </section>
                                </section>
                                {/if}
                            {/each}
                        {/if}   
                    </section>
                </section>
            {/if}
            {/each}
            <section class="h-12"></section>
        </section>
        <section id="footer" class="m-auto my-12" on:click|stopPropagation={()=>{page.route('/lists/items/item-generic?list_uid=recurring&redirect=/lists/items/store')}} >
            Add new recurring
        </section>
</section>

<style>
</style>